module.exports = __webpack_public_path__ + "static/media/riley-icon.a7d96dc7.jpg";